<template>
  <eg-table-filters-base
    :available-filters="availableFilters"
    :all-available-filters="allAvailableFilters"
    :default-selected-filters="defaultSelectedFilters"
    :available-sorts="['name', 'createdAt']"
    :show-add-filter="true"
    :can-remove-filters="true"
    :show-clear-all="true"
    :show-search="true"
    class="p-3"
    data-testid="eg-table-base-filters"
    :is-filtered="isFiltered"
    @filter-changed="$emit('filter-changed', $event)"
    @sort-changed="$emit('filter-changed', $event)"
  />
</template>

<script>
import { GRADE_LEVELS } from "@/constants";
import { mapGetters } from "vuex";
import { EgTableFiltersBase } from "@/components/global/eg/eg_table";

export default {
  name: "RubricsTableFilters",

  components: {
    EgTableFiltersBase,
  },

  props: {
    availableFilters: {
      type: Array,
      default: () => ["gradeLevel", "languageId", "createdAt"],
    },
    total: {
      type: Number,
      default: 0,
    },
    limit: {
      type: Number,
      default: 0,
    },
    isFiltered: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      defaultSelectedFilters: [
        { key: "gradeLevel", value: null, isActive: false },
      ],
      languageItems: [],
    };
  },

  computed: {
    ...mapGetters("languages", ["getLanguagesList"]),

    allAvailableFilters() {
      return {
        gradeLevel: {
          title: this.$t("rubrics.gradeFilter"),
          key: "gradeLevel",
          prepareValue: (value) =>
            this.allAvailableFilters.gradeLevel.items.find(
              (item) => item.id === value
            ),
          component: "filter-select",
          items: GRADE_LEVELS.map((level) => ({
            id: level.value,
            name: this.$t(level.translationKey),
          })),
        },
        languageId: {
          title: this.$t("rubrics.languageFilter"),
          key: "languageId",
          prepareValue: (value) =>
            this.allAvailableFilters.languageId.items?.find(
              (item) => item.id === value
            ),
          component: "filter-select",
          items: this.languageItems,
        },
        name: {
          filterName: this.$t("rubrics.rubricName"),
          title: this.$t("rubrics.rubricNameFilter"),
          key: "name",
          prepareValue: (value) => value.toString(),
          component: "input-filter",
        },
        createdAt: {
          title: this.$t("rubrics.createdDateRange"),
          key: "createdAt",
          prepareValue: (value) => {
            if (!value || (!value.from && !value.to)) return null;
            return value;
          },
          component: "date-range",
        },
      };
    },
  },

  watch: {
    getLanguagesList: {
      handler(languages) {
        this.languageItems = languages.map((lang) => ({
          id: lang.value,
          name: lang.text,
        }));
      },
      immediate: true,
    },
  },
};
</script>
